<!-- <app-layout>
    <app-header></app-header>
    <main>
        <router-outlet></router-outlet>
    </main>
</app-layout> -->


<app-layout>
    <mat-sidenav-container>
      <mat-sidenav [fixedInViewport]="true"  [mode]="'side'" [opened]="'open'">
        <app-sidenav-list></app-sidenav-list>
      </mat-sidenav>
      <mat-sidenav-content>
        <app-header></app-header>
        <main>
          <div class="bg-comman">
            <router-outlet></router-outlet>
          </div>
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
</app-layout>
